import { sendPasswordResetEmail } from 'firebase/auth';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Logo from '../../assets/logo-dark.png';
import { forgotPassword } from '../../lib/firebase/Authentication/PasswordAuth';
import Styles from './ForgotPassword.module.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [emailSent, setEmailSent] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setisLoading] = useState(false);

  const navigate = useNavigate();

  return (
    <div>
      <div className={Styles.headerContainer}>
        <img
          className={Styles.logoIcon}
          src={Logo}
          alt={'Website logo'}
          onClick={() => navigate('/')}
        />
      </div>
      <div className={Styles.container}>
        {!emailSent ? (
          <div className={Styles.formCard}>
            <div className={Styles.title}>
              <h1>Reset Your Password</h1>
              <p>
                Enter your email address and we'll send you a link to reset your
                password.
              </p>
            </div>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                forgotPassword(email, navigate);
              }}
            >
              <div className={Styles.inputGroup}>
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  required
                />
              </div>

              {error && (
                <div className={Styles.errorContainer}>
                  <p>{error}</p>
                </div>
              )}

              <button
                type="submit"
                className={Styles.submitButton}
                disabled={isLoading}
              >
                {isLoading ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>

            <div className={Styles.backToLogin}>
              <p>
                Remember your password?{' '}
                <span onClick={() => navigate('/login')}>Log in</span>
              </p>
            </div>
          </div>
        ) : (
          <div className={Styles.successCard}>
            <div className={Styles.successIcon}>✓</div>
            <h2>Check Your Email</h2>
            <p>
              We've sent a password reset link to <strong>{email}</strong>
            </p>
            <p className={Styles.instructions}>
              Click the link in the email to reset your password. If you don't
              see the email, check your spam folder.
            </p>
            <button
              className={Styles.returnButton}
              onClick={() => navigate('/login')}
            >
              Return to Login
            </button>
            <div className={Styles.resendLink}>
              <p>
                Didn't receive the email?{' '}
                <span onClick={() => setEmailSent(false)}>Try again</span>
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
